import Confirm from "./component.vue";

type OptionsType = {
  message: string;
};

const AppAlert = (Vue) => {
  const property = "$confirm";

  const VueCreator = Vue.extend(Confirm);
  const createDialogCmp = (options) => {
    const container = document.querySelector("[data-app=true]") || document.body;
    return new Promise((resolve) => {
      const cmp = new VueCreator(
        Object.assign(
          {},
          {
            propsData: Object.assign({}, Vue.prototype[property].options, options),
            destroyed: () => {
              container.removeChild(cmp.$el);
              resolve(cmp.value);
            },
          }
        )
      );
      container.appendChild(cmp.$mount().$el);
    });
  };

  const show = (message, options: OptionsType) => {
    options.message = message;
    return createDialogCmp(options);
  };

  Vue.prototype[property] = show;
  Vue.prototype[property].options = {};
};

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(AppAlert);
}

export default AppAlert;
